export const gt = {
  crew: [
    {
      expanded: true,
      label: "Franchise",
      data: {
        name: "Gujarat Titans",
        avatar: "gt.jpg",
      },
      image:
        "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/GT/Logos/Logooutline/GToutline.png",
      children: [
        {
          expanded: true,
          label: "Captain",
          data: {
            name: "Hardik Pandya",
            avatar: "hardik_pandya.jpg",
          },
          image:
            "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/54.png",
          children: [
            {
              expanded: true,
              label: "Batsmen",
              image:
                "https://www.iplt20.com/assets/images/teams-batsman-icon.svg",
              data: {
                name: "David Miller, Shubman Gill, Mathew Wade, K.S.Bharat",
              },
              children: [
                {
                  label: "David Miller",
                  data: {
                    name: "David Miller",
                    avatar: "david_miller.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/128.png",
                },
                {
                  label: "Shubman Gill",
                  data: {
                    name: "Shubman Gill",
                    avatar: "shubman_gill.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/62.png",
                },
                {
                  label: "Mathew Wade",
                  data: {
                    name: "Mathew Wade",
                    avatar: "mathew_wade.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/549.png",
                },
                {
                  label: "K.S.Bharath",
                  data: {
                    name: "K.S.Bharat",
                    avatar: "ksbharat.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/365.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Bowlers",
              image:
                "https://www.iplt20.com/assets/images/teams-bowler-icon.svg",
              data: {
                name: "Mohammad Shami, Rashid Khan, Jayant Yadav, Noor Ahmed",
              },
              children: [
                {
                  label: "Mohammad Shami",
                  data: {
                    name: "Mohammad Shami",
                    avatar: "shami.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/47.png",
                },
                {
                  label: "Rashid Khan",
                  data: {
                    name: "Rashid Khan",
                    avatar: "rashid_khan.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/218.png",
                },
                {
                  label: "Jayant Yadav",
                  data: {
                    name: "Jayant Yadav",
                    avatar: "kuldeep_yadav.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/165.png",
                },
                {
                  label: "Noor Ahmed",
                  data: {
                    name: "Noor Ahmed",
                    avatar: "noor_ahmed.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/975.png",
                },
              ],
            },
            {
              expanded: true,
              label: "All-rounders",
              image:
                "https://www.iplt20.com/assets/images/teams-all-rounder-icon.svg",
              data: {
                name: "Hardik Pandya, Vijay Shankar, Odean Smith",
              },
              children: [
                {
                  label: "Hardik Pandya",
                  data: {
                    name: "Hardik Pandya",
                    avatar: "hardik_pandya.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/54.png",
                },
                {
                  label: "Vijay Shankar",
                  data: {
                    name: "Vijay Shankar",
                    avatar: "vijay_shankar.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/61.png",
                },
                {
                  label: "Odean Smith",
                  data: {
                    name: "Odean Smith",
                    avatar: "odean_smith.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/863.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Wicket-keeper",
              image:
                "https://www.iplt20.com/assets/images/teams-wicket-keeper-icon.svg",
              data: {
                name: "Mathew Wade",
              },
              children: [
                {
                  label: "Mathew Wade",
                  data: {
                    name: "Mathew Wade",
                    avatar: "mathew_wade.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/549.png",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const srh = {
  crew: [
    {
      expanded: true,
      label: "Franchise",
      data: {
        name: "Sunrisers Hydrabad",
        avatar: "srh.jpg",
      },
      image:
        "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/SRH/Logos/Logooutline/SRHoutline.png",
      children: [
        {
          expanded: true,
          label: "Captain",
          data: {
            name: "Kane Williamson",
            avatar: "kane_williamson.jpg",
          },
          image:
            "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/440.png",
          children: [
            {
              expanded: true,
              label: "Batsmen",
              image:
                "https://www.iplt20.com/assets/images/teams-batsman-icon.svg",
              data: {
                name: "Kane Williamson, David Warner, Manish Pandey, Priyam Garg",
              },
              children: [
                {
                  label: "Kane Williamson",
                  data: {
                    name: "Kane Williamson",
                    avatar: "kane_williamson.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/440.png",
                },
                {
                  label: "David Warner",
                  data: {
                    name: "David Warner",
                    avatar: "david_warner.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/170.png",
                },
                {
                  label: "Manish Pandey",
                  data: {
                    name: "Manish Pandey",
                    avatar: "manish_pandey.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/123.png",
                },
                {
                  label: "Priyam Garg",
                  data: {
                    name: "Priyam Garg",
                    avatar: "priyam_garg.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/3775.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Bowlers",
              image:
                "https://www.iplt20.com/assets/images/teams-bowler-icon.svg",
              data: {
                name: "Bhuvneshwar Kumar, Rashid Khan, Sandeep Sharma, T Natarajan",
              },
              children: [
                {
                  label: "Bhuvneshwar Kumar",
                  data: {
                    name: "Bhuvneshwar Kumar",
                    avatar: "bhuvneshwar_kumar.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/116.png",
                },
                {
                  label: "Rashid Khan",
                  data: {
                    name: "Rashid Khan",
                    avatar: "rashid_khan.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/2885.png",
                },
                {
                  label: "Sandeep Sharma",
                  data: {
                    name: "Sandeep Sharma",
                    avatar: "sandeep_sharma.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1112.png",
                },
                {
                  label: "T Natarajan",
                  data: {
                    name: "T Natarajan",
                    avatar: "t_natarajan.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/3831.png",
                },
              ],
            },
            {
              label: "All-rounders",
              image:
                "https://www.iplt20.com/assets/images/teams-all-rounder-icon.svg",
              data: {
                name: "Jason Holder, Mohammad Nabi, Vijay Shankar",
              },
              children: [
                {
                  label: "Jason Holder",
                  data: {
                    name: "Jason Holder",
                    avatar: "jason_holder.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1075.png",
                },
                {
                  label: "Mohammad Nabi",
                  data: {
                    name: "Mohammad Nabi",
                    avatar: "mohammad_nabi.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/618.png",
                },
                {
                  label: "Vijay Shankar",
                  data: {
                    name: "Vijay Shankar",
                    avatar: "vijay_shankar.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1083.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Wicket-keeper",
              image:
                "https://www.iplt20.com/assets/images/teams-wicket-keeper-icon.svg",
              data: {
                name: "Jonny Bairstow",
              },
              children: [
                {
                  label: "Jonny Bairstow",
                  data: {
                    name: "Jonny Bairstow",
                    avatar: "jonny_bairstow.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/506.png",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const vel = {
  crew: [
    {
      expanded: true,
      label: "Franchise",
      data: {
        name: "Velocity",
        avatar: "vel.jpg",
      },
      image: "https://scores.iplt20.com/ipl/teamlogos/VelocityRB.png",
      children: [
        {
          expanded: true,
          label: "Captain",
          data: {
            name: "Deepti Sharma",
            avatar: "deepti_sharma.jpg",
          },
          image: "https://scores.iplt20.com/ipl/playerimages/395-small.png?v=2",
          children: [
            {
              expanded: true,
              label: "Batsmen",
              image:
                "https://www.iplt20.com/assets/images/teams-batsman-icon.svg",
              data: {
                name: "Shafali Verma, K P Navgire, Deepti Sharma ,Natthakan Chantham",
              },
              children: [
                {
                  label: "Shafali Verma",
                  data: {
                    name: "Shafali Verma",
                    avatar: "shafali_verma.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/398-small.png?v=2",
                },
                {
                  label: " K P Navgire",
                  data: {
                    name: " K P Navgire",
                    avatar: "k_p_navgire.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/1040-small.png?v=2",
                },
                {
                  label: "Deepti Sharma",
                  data: {
                    name: "Deepti Sharma",
                    avatar: "deepti_sharma.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/395-small.png?v=2",
                },
                {
                  label: "Natthakan Chantham",
                  data: {
                    name: "Natthakan Chantham",
                    avatar: "natthakan_chantham.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/1039-small.png?v=2",
                },
              ],
            },
            {
              expanded: true,
              label: "Bowlers",
              image:
                "https://www.iplt20.com/assets/images/teams-bowler-icon.svg",
              data: {
                name: "Laura Wolvaardt, Sneh Rana, Radha Yadav, Kathryn Laura Cross",
              },
              children: [
                {
                  label: "Laura Wolvaardt",
                  data: {
                    name: "Laura Wolvaardt",
                    avatar: "laura_wolvaardt.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/436-small.png?v=2",
                },
                {
                  label: "Sneh Rana",
                  data: {
                    name: "Sneh Rana",
                    avatar: "sneh_rana.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/887-small.png?v=2",
                },
                {
                  label: "Radha Yadav",
                  data: {
                    name: "Radha Yadav",
                    avatar: "radha_yadav.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/400-small.png?v=2",
                },
                {
                  label: "Kathryn Laura Cross",
                  data: {
                    name: "Kathryn Laura Cross",
                    avatar: "kathryn_laura_cross.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/1035-small.png?v=2",
                },
              ],
            },
            {
              expanded: true,
              label: "All-rounders",
              image:
                "https://www.iplt20.com/assets/images/teams-all-rounder-icon.svg",
              data: {
                name: "Simran Bahadur, Ayabonga Khaka",
              },
              children: [
                {
                  label: "Simran Bahadur",
                  data: {
                    name: "Simran Bahadur",
                    avatar: "simran_bahadur.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/882-small.png?v=2",
                },
                {
                  label: "Ayabonga Khaka",
                  data: {
                    name: "Ayabonga Khaka",
                    avatar: "ayabonga_khaka.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/442-small.png?v=2",
                },
              ],
            },
            {
              expanded: true,
              label: "Wicket-keeper",
              image:
                "https://www.iplt20.com/assets/images/teams-wicket-keeper-icon.svg",
              data: {
                name: "Yastika Bhatia",
              },
              children: [
                {
                  label: "Yastika Bhatia",
                  data: {
                    name: "Yastika Bhatia",
                    avatar: "yastika_bhatia.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/883-small.png?v=2",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const pbks = {
  crew: [
    {
      expanded: true,
      label: "Franchise",
      data: {
        name: "Punjab Kings",
        avatar: "pbks.jpg",
      },
      image:
        "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/PBKS/Logos/Logooutline/PBKSoutline.png",
      children: [
        {
          expanded: true,
          label: "Captain",
          data: {
            name: "KL Rahul",
            avatar: "kl_rahul.jpg",
          },
          image: "images/organization/kl_rahul.jpg",
          children: [
            {
              expanded: true,
              label: "Batsmen",
              image:
                "https://www.iplt20.com/assets/images/teams-batsman-icon.svg",
              data: {
                name: "KL Rahul, Chris Gayle, Mayank Agarwal, Dawid Malan",
              },
              children: [
                {
                  label: "KL Rahul",
                  data: {
                    name: "KL Rahul",
                    avatar: "kl_rahul.jpg",
                  },
                  image: "images/organization/kl_rahul.jpg",
                },
                {
                  label: "Chris Gayle",
                  data: {
                    name: "Chris Gayle",
                    avatar: "chris_gayle.jpg",
                  },
                  image: "images/organization/chris_gayle.jpg",
                },
                {
                  label: "Mayank Agarwal",
                  data: {
                    name: "Mayank Agarwal",
                    avatar: "mayank_agarwal.jpg",
                  },
                  image: "images/organization/mayank_agarwal.jpg",
                },
                {
                  label: "Dawid Malan",
                  data: {
                    name: "Dawid Malan",
                    avatar: "dawid_malan.jpg",
                  },
                  image: "images/organization/dawid_malan.jpg",
                },
              ],
            },
            {
              expanded: true,
              label: "Bowlers",
              image:
                "https://www.iplt20.com/assets/images/teams-bowler-icon.svg",
              data: {
                name: "Mohammed Shami, Chris Jordan, Ravi Bishnoi, Jhye Richardson",
              },
              children: [
                {
                  label: "Mohammed Shami",
                  data: {
                    name: "Mohammed Shami",
                    avatar: "mohammed_shami.jpg",
                  },
                  image: "images/organization/mohammed_shami.jpg",
                },
                {
                  label: "Chris Jordan",
                  data: {
                    name: "Chris Jordan",
                    avatar: "chris_jordan.jpg",
                  },
                  image: "images/organization/chris_jordan.jpg",
                },
                {
                  label: "Ravi Bishnoi",
                  data: {
                    name: "Ravi Bishnoi",
                    avatar: "ravi_bishnoi.jpg",
                  },
                  image: "images/organization/ravi_bishnoi.jpg",
                },
                {
                  label: "Jhye Richardson",
                  data: {
                    name: "Jhye Richardson",
                    avatar: "jhye_richardson.jpg",
                  },
                  image: "images/organization/jhye_richardson.jpg",
                },
              ],
            },
            {
              expanded: true,
              label: "All-rounders",
              image:
                "https://www.iplt20.com/assets/images/teams-all-rounder-icon.svg",
              data: {
                name: "Deepak Hooda, Shahrukh Khan, Moises Henriques",
              },
              children: [
                {
                  label: "Deepak Hooda",
                  data: {
                    name: "Deepak Hooda",
                    avatar: "deepak_hooda.jpg",
                  },
                  image: "images/organization/deepak_hooda.jpg",
                },
                {
                  label: "Shahrukh Khan",
                  data: {
                    name: "Shahrukh Khan",
                    avatar: "shahrukh_khan.jpg",
                  },
                  image: "images/organization/shahrukh_khan.jpg",
                },
                {
                  label: "Moises Henriques",
                  data: {
                    name: "Moises Henriques",
                    avatar: "moises_henriques.jpg",
                  },
                  image: "images/organization/moises_henriques.jpg",
                },
              ],
            },
            {
              expanded: true,
              label: "Wicket-keeper",
              image:
                "https://www.iplt20.com/assets/images/teams-wicket-keeper-icon.svg",
              data: {
                name: "KL Rahul",
              },
              children: [
                {
                  label: "KL Rahul",
                  data: {
                    name: "KL Rahul",
                    avatar: "kl_rahul.jpg",
                  },
                  image: "images/organization/kl_rahul.jpg",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const csk = {
  crew: [
    {
      expanded: true,
      label: "Franchise",
      data: {
        name: "Chennai Super Kings",
        avatar: "chennai.jpg",
      },
      image:
        "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/CSK/logos/Logooutline/CSKoutline.png",
      children: [
        {
          expanded: true,
          label: "Captain",
          data: {
            name: "MS Dhoni",
            avatar: "dhoni.jpg",
          },
          image:
            "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1.png",
          children: [
            {
              expanded: true,
              label: "Batsmen",
              image:
                "https://www.iplt20.com/assets/images/teams-batsman-icon.svg",
              data: {
                name: "Suresh Raina, Faf du Plessis, Ruturaj Gaikwad, Ambati Rayudu, Robin Uthappa",
              },
              children: [
                {
                  label: "Suresh Raina",
                  data: {
                    name: "Suresh Raina",
                    avatar: "raina.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/14.png",
                },
                {
                  label: "Faf du Plessis",
                  data: {
                    name: "Faf du Plessis",
                    avatar: "faf.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/24.png",
                },
                {
                  label: "Ruturaj Gaikwad",
                  data: {
                    name: "Ruturaj Gaikwad",
                    avatar: "gaikwad.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/5443.png",
                },
                {
                  label: "Ambati Rayudu",
                  data: {
                    name: "Ambati Rayudu",
                    avatar: "rayudu.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/100.png",
                },
                {
                  label: "Robin Uthappa",
                  data: {
                    name: "Robin Uthappa",
                    avatar: "uthappa.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/127.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Bowlers",
              image:
                "https://www.iplt20.com/assets/images/teams-bowler-icon.svg",
              data: {
                name: "Deepak Chahar, Shardul Thakur, Lungi Ngidi, Josh Hazlewood, Imran Tahir, Karn Sharma, R Sai Kishore",
              },
              children: [
                {
                  label: "Deepak Chahar",
                  data: {
                    name: "Deepak Chahar",
                    avatar: "chahar.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/140.png",
                },
                {
                  label: "Shardul Thakur",
                  data: {
                    name: "Shardul Thakur",
                    avatar: "thakur.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1745.png",
                },
                {
                  label: "Lungi Ngidi",
                  data: {
                    name: "Lungi Ngidi",
                    avatar: "ngidi.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/3746.png",
                },
                {
                  label: "Josh Hazlewood",
                  data: {
                    name: "Josh Hazlewood",
                    avatar: "hazlewood.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/857.png",
                },
                {
                  label: "Imran Tahir",
                  data: {
                    name: "Imran Tahir",
                    avatar: "tahir.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/898.png",
                },
                {
                  label: "Karn Sharma",
                  data: {
                    name: "Karn Sharma",
                    avatar: "sharma.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1118.png",
                },
                {
                  label: "R Sai Kishore",
                  data: {
                    name: "R Sai Kishore",
                    avatar: "kishore.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/7123.png",
                },
              ],
            },
            {
              expanded: true,
              label: "All-rounders",
              image:
                "https://www.iplt20.com/assets/images/teams-all-rounder-icon.svg",
              data: {
                name: "Ravindra Jadeja, Sam Curran, Dwayne Bravo, Moeen Ali",
              },
              children: [
                {
                  label: "Ravindra Jadeja",
                  data: {
                    name: "Ravindra Jadeja",
                    avatar: "jadeja.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/9.png",
                },
                {
                  label: "Sam Curran",
                  data: {
                    name: "Sam Curran",
                    avatar: "curran.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/2939.png",
                },
                {
                  label: "Dwayne Bravo",
                  data: {
                    name: "Dwayne Bravo",
                    avatar: "bravo.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/25.png",
                },
                {
                  label: "Moeen Ali",
                  data: {
                    name: "Moeen Ali",
                    avatar: "ali.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1735.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Wicket-keeper",
              image:
                "https://www.iplt20.com/assets/images/teams-wicket-keeper-icon.svg",
              data: {
                name: "N Jagadeesan",
              },
              children: [
                {
                  label: "N Jagadeesan",
                  data: {
                    name: "N Jagadeesan",
                    avatar: "jagadeesan.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/4942.png",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
export const mi = {
  crew: [
    {
      expanded: true,
      label: "Franchise",
      data: {
        name: "Mumbai Indians",
        avatar: "mumbai_indians.jpg",
      },
      image:
        "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/MI/Logos/Logooutline/MIoutline.png",
      children: [
        {
          expanded: true,
          label: "Captain",
          data: {
            name: "Rohit Sharma",
            avatar: "rohit_sharma.jpg",
          },
          image:
            "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/107.png",
          children: [
            {
              expanded: true,
              label: "Batsmen",
              image:
                "https://www.iplt20.com/assets/images/teams-batsman-icon.svg",
              data: {
                name: "Rohit Sharma, Quinton de Kock, Suryakumar Yadav, Ishan Kishan",
              },
              children: [
                {
                  label: "Rohit Sharma",
                  data: {
                    name: "Rohit Sharma",
                    avatar: "rohit_sharma.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/107.png",
                },
                {
                  label: "Quinton de Kock",
                  data: {
                    name: "Quinton de Kock",
                    avatar: "quinton_de_kock.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/834.png",
                },
                {
                  label: "Suryakumar Yadav",
                  data: {
                    name: "Suryakumar Yadav",
                    avatar: "suryakumar_yadav.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/108.png",
                },
                {
                  label: "Ishan Kishan",
                  data: {
                    name: "Ishan Kishan",
                    avatar: "ishan_kishan.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/2975.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Bowlers",
              image:
                "https://www.iplt20.com/assets/images/teams-bowler-icon.svg",
              data: {
                name: "Jasprit Bumrah, Trent Boult, Rahul Chahar, Nathan Coulter-Nile",
              },
              children: [
                {
                  label: "Jasprit Bumrah",
                  data: {
                    name: "Jasprit Bumrah",
                    avatar: "jasprit_bumrah.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1124.png",
                },
                {
                  label: "Trent Boult",
                  data: {
                    name: "Trent Boult",
                    avatar: "trent_boult.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/969.png",
                },
                {
                  label: "Rahul Chahar",
                  data: {
                    name: "Rahul Chahar",
                    avatar: "rahul_chahar.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/3763.png",
                },
                {
                  label: "Nathan Coulter-Nile",
                  data: {
                    name: "Nathan Coulter-Nile",
                    avatar: "nathan_coulter_nile.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/840.png",
                },
              ],
            },
            {
              expanded: true,
              label: "All-rounders",
              image:
                "https://www.iplt20.com/assets/images/teams-all-rounder-icon.svg",
              data: {
                name: "Kieron Pollard, Hardik Pandya",
              },
              children: [
                {
                  label: "Kieron Pollard",
                  data: {
                    name: "Kieron Pollard",
                    avatar: "kieron_pollard.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/210.png",
                },
                {
                  label: "Hardik Pandya",
                  data: {
                    name: "Hardik Pandya",
                    avatar: "hardik_pandya.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/2740.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Wicket-keeper",
              image:
                "https://www.iplt20.com/assets/images/teams-wicket-keeper-icon.svg",
              data: {
                name: "Quinton de Kock",
              },
              children: [
                {
                  label: "Quinton de Kock",
                  data: {
                    name: "Quinton de Kock",
                    avatar: "quinton_de_kock.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/834.png",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const rcb = {
  crew: [
    {
      expanded: true,
      label: "Franchise",
      data: {
        name: "Royal Challengers Bangalore",
        avatar: "rcb.jpg",
      },
      image:
        "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/RCB/Logos/Logooutline/RCBoutline.png",
      children: [
        {
          expanded: true,
          label: "Captain",
          data: {
            name: "Virat Kohli",
            avatar: "virat_kohli.jpg",
          },
          image:
            "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/164.png",
          children: [
            {
              expanded: true,
              label: "Batsmen",
              image:
                "https://www.iplt20.com/assets/images/teams-batsman-icon.svg",
              data: {
                name: "Virat Kohli, Devdutt Padikkal, AB de Villiers, Glenn Maxwell",
              },
              children: [
                {
                  label: "Virat Kohli",
                  data: {
                    name: "Virat Kohli",
                    avatar: "virat_kohli.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/164.png",
                },
                {
                  label: "Devdutt Padikkal",
                  data: {
                    name: "Devdutt Padikkal",
                    avatar: "devdutt_padikkal.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/5430.png",
                },
                {
                  label: "AB de Villiers",
                  data: {
                    name: "AB de Villiers",
                    avatar: "ab_de_villiers.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/233.png",
                },
                {
                  label: "Glenn Maxwell",
                  data: {
                    name: "Glenn Maxwell",
                    avatar: "glenn_maxwell.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/282.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Bowlers",
              image:
                "https://www.iplt20.com/assets/images/teams-bowler-icon.svg",
              data: {
                name: "Mohammed Siraj, Yuzvendra Chahal, Navdeep Saini, Kane Richardson",
              },
              children: [
                {
                  label: "Mohammed Siraj",
                  data: {
                    name: "Mohammed Siraj",
                    avatar: "mohammed_siraj.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/3840.png",
                },
                {
                  label: "Yuzvendra Chahal",
                  data: {
                    name: "Yuzvendra Chahal",
                    avatar: "yuzvendra_chahal.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/111.png",
                },
                {
                  label: "Navdeep Saini",
                  data: {
                    name: "Navdeep Saini",
                    avatar: "navdeep_saini.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/3824.png",
                },
                {
                  label: "Kane Richardson",
                  data: {
                    name: "Kane Richardson",
                    avatar: "kane_richardson.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/798.png",
                },
              ],
            },
            {
              expanded: true,
              label: "All-rounders",
              image:
                "https://www.iplt20.com/assets/images/teams-all-rounder-icon.svg",
              data: {
                name: "Washington Sundar, Kyle Jamieson, Dan Christian",
              },
              children: [
                {
                  label: "Washington Sundar",
                  data: {
                    name: "Washington Sundar",
                    avatar: "washington_sundar.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/2973.png",
                },
                {
                  label: "Kyle Jamieson",
                  data: {
                    name: "Kyle Jamieson",
                    avatar: "kyle_jamieson.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1616.png",
                },
                {
                  label: "Dan Christian",
                  data: {
                    name: "Dan Christian",
                    avatar: "dan_christian.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/181.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Wicket-keeper",
              image:
                "https://www.iplt20.com/assets/images/teams-wicket-keeper-icon.svg",
              data: {
                name: "AB de Villiers",
              },
              children: [
                {
                  label: "AB de Villiers",
                  data: {
                    name: "AB de Villiers",
                    avatar: "ab_de_villiers.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/233.png",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const kkr = {
  crew: [
    {
      expanded: true,
      label: "Franchise",
      data: {
        name: "Kolkata Knight Riders",
        avatar: "kkr.jpg",
      },
      image:
        "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/KKR/Logos/Logooutline/KKRoutline.png",
      children: [
        {
          expanded: true,
          label: "Captain",
          data: {
            name: "Eoin Morgan",
            avatar: "eoin_morgan.jpg",
          },
          image:
            "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/197.png",
          children: [
            {
              expanded: true,
              label: "Batsmen",
              image:
                "https://www.iplt20.com/assets/images/teams-batsman-icon.svg",
              data: {
                name: "Shubman Gill, Nitish Rana, Rahul Tripathi, Dinesh Karthik",
              },
              children: [
                {
                  label: "Shubman Gill",
                  data: {
                    name: "Shubman Gill",
                    avatar: "shubman_gill.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/3761.png",
                },
                {
                  label: "Nitish Rana",
                  data: {
                    name: "Nitish Rana",
                    avatar: "nitish_rana.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/2738.png",
                },
                {
                  label: "Rahul Tripathi",
                  data: {
                    name: "Rahul Tripathi",
                    avatar: "rahul_tripathi.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/3838.png",
                },
                {
                  label: "Dinesh Karthik",
                  data: {
                    name: "Dinesh Karthik",
                    avatar: "dinesh_karthik.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/102.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Bowlers",
              image:
                "https://www.iplt20.com/assets/images/teams-bowler-icon.svg",
              data: {
                name: "Pat Cummins, Varun Chakravarthy, Lockie Ferguson, Prasidh Krishna",
              },
              children: [
                {
                  label: "Pat Cummins",
                  data: {
                    name: "Pat Cummins",
                    avatar: "pat_cummins.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/488.png",
                },
                {
                  label: "Varun Chakravarthy",
                  data: {
                    name: "Varun Chakravarthy",
                    avatar: "varun_chakravarthy.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/5432.png",
                },
                {
                  label: "Lockie Ferguson",
                  data: {
                    name: "Lockie Ferguson",
                    avatar: "lockie_ferguson.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/3729.png",
                },
                {
                  label: "Prasidh Krishna",
                  data: {
                    name: "Prasidh Krishna",
                    avatar: "prasidh_krishna.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/5105.png",
                },
              ],
            },
            {
              expanded: true,
              label: "All-rounders",
              image:
                "https://www.iplt20.com/assets/images/teams-all-rounder-icon.svg",
              data: {
                name: "Andre Russell, Sunil Narine, Shakib Al Hasan",
              },
              children: [
                {
                  label: "Andre Russell",
                  data: {
                    name: "Andre Russell",
                    avatar: "andre_russell.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/177.png",
                },
                {
                  label: "Sunil Narine",
                  data: {
                    name: "Sunil Narine",
                    avatar: "sunil_narine.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/203.png",
                },
                {
                  label: "Shakib Al Hasan",
                  data: {
                    name: "Shakib Al Hasan",
                    avatar: "shakib_al_hasan.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/201.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Wicket-keeper",
              image:
                "https://www.iplt20.com/assets/images/teams-wicket-keeper-icon.svg",
              data: {
                name: "Dinesh Karthik",
              },
              children: [
                {
                  label: "Dinesh Karthik",
                  data: {
                    name: "Dinesh Karthik",
                    avatar: "dinesh_karthik.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/102.png",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const lsg = {
  crew: [
    {
      expanded: true,
      label: "Franchise",
      data: {
        name: "Lucknow Super Giants",
        avatar: "lsg.jpg",
      },
      image:
        "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/LSG/Logos/Logooutline/LSGoutline.png",
      children: [
        {
          expanded: true,
          label: "Captain",
          data: {
            name: "KL Rahul",
            avatar: "kl_rahul.jpg",
          },
          image:
            "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/19.png",
          children: [
            {
              label: "Batsmen",
              image:
                "https://www.iplt20.com/assets/images/teams-batsman-icon.svg",
              data: {
                name: "KL Rahul, Nicholas Pooran, Manan Vohra, Quinton de Kock",
              },
              children: [
                {
                  label: "KL Rahul",
                  data: {
                    name: "KL Rahul",
                    avatar: "kl_rahul.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/19.png",
                },
                {
                  label: "Nicholas Pooran",
                  data: {
                    name: "Nicholas Pooran",
                    avatar: "nicholas_pooran.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/136.png",
                },
                {
                  label: "Manan Vohra",
                  data: {
                    name: "Manan Vohra",
                    avatar: "manan_vohra.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/185.png",
                },
                {
                  label: "Quinton de Kock",
                  data: {
                    name: "Quinton de Kock",
                    avatar: "quniton_de_kock.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/170.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Bowlers",
              image:
                "https://www.iplt20.com/assets/images/teams-bowler-icon.svg",
              data: {
                name: "Avesh Khan, Mark Wood, Ravi Bishnoi, Amit Mishra",
              },
              children: [
                {
                  label: "Avesh Khan",
                  data: {
                    name: "Avesh Khan",
                    avatar: "avesh_khan.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/109.png",
                },
                {
                  label: "Mark Wood",
                  data: {
                    name: "Mark Wood",
                    avatar: "mark_wood.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/315.png",
                },
                {
                  label: "Ravi Bishnoi",
                  data: {
                    name: "Ravi Bishnoi",
                    avatar: "ravi_bishnoi.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/520.png",
                },
                {
                  label: "Amit Mishra",
                  data: {
                    name: "Amit Mishra",
                    avatar: "amit_mishra.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/107.png",
                },
              ],
            },
            {
              expanded: true,
              label: "All-rounders",
              image:
                "https://www.iplt20.com/assets/images/teams-all-rounder-icon.svg",
              data: {
                name: "Deepak Hooda, Marcus Stoinis, Krunal Pandya",
              },
              children: [
                {
                  label: "Deepak Hooda",
                  data: {
                    name: "Deepak Hooda",
                    avatar: "deepak_hooda.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/215.png",
                },
                {
                  label: "Marcus Stoinis",
                  data: {
                    name: "Marcus Stoinis",
                    avatar: "marcus_stoinis.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/23.png",
                },
                {
                  label: "Krunal Pandya",
                  data: {
                    name: "Krunal Pandya",
                    avatar: "krunal_pandya.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/17.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Wicket-keeper",
              image:
                "https://www.iplt20.com/assets/images/teams-wicket-keeper-icon.svg",
              data: {
                name: "KL Rahul",
              },
              children: [
                {
                  label: "KL Rahul",
                  data: {
                    name: "KL Rahul",
                    avatar: "kl_rahul.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/IPLHeadshot2023/19.png",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const rr = {
  crew: [
    {
      expanded: true,
      label: "Franchise",
      data: {
        name: "Rajasthan Royals",
        avatar: "rr.jpg",
      },
      image:
        "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/RR/Logos/Logooutline/RRoutline.png",
      children: [
        {
          expanded: true,
          label: "Captain",
          data: {
            name: "Sanju Samson",
            avatar: "sanju_samson.jpg",
          },
          image:
            "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/258.png",
          children: [
            {
              expanded: true,
              label: "Batsmen",
              image:
                "https://www.iplt20.com/assets/images/teams-batsman-icon.svg",
              data: {
                name: "Sanju Samson, Jos Buttler, David Miller, Manan Vohra",
              },
              children: [
                {
                  label: "Sanju Samson",
                  data: {
                    name: "Sanju Samson",
                    avatar: "sanju_samson.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/258.png",
                },
                {
                  label: "Jos Buttler",
                  data: {
                    name: "Jos Buttler",
                    avatar: "jos_buttler.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/509.png",
                },
                {
                  label: "David Miller",
                  data: {
                    name: "David Miller",
                    avatar: "david_miller.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/187.png",
                },
                {
                  label: "Manan Vohra",
                  data: {
                    name: "Manan Vohra",
                    avatar: "manan_vohra.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1085.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Bowlers",
              image:
                "https://www.iplt20.com/assets/images/teams-bowler-icon.svg",
              data: {
                name: "Chris Morris, Jaydev Unadkat, Mustafizur Rahman, Shreyas Gopal",
              },
              children: [
                {
                  label: "Chris Morris",
                  data: {
                    name: "Chris Morris",
                    avatar: "chris_morris.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/836.png",
                },
                {
                  label: "Jaydev Unadkat",
                  data: {
                    name: "Jaydev Unadkat",
                    avatar: "jaydev_unadkat.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/86.png",
                },
                {
                  label: "Mustafizur Rahman",
                  data: {
                    name: "Mustafizur Rahman",
                    avatar: "mustafizur_rahman.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1594.png",
                },
                {
                  label: "Shreyas Gopal",
                  data: {
                    name: "Shreyas Gopal",
                    avatar: "shreyas_gopal.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1748.png",
                },
              ],
            },
            {
              expanded: true,
              label: "All-rounders",
              image:
                "https://www.iplt20.com/assets/images/teams-all-rounder-icon.svg",
              data: {
                name: "Riyan Parag, Ben Stokes, Rahul Tewatia",
              },
              children: [
                {
                  label: "Riyan Parag",
                  data: {
                    name: "Riyan Parag",
                    avatar: "riyan_parag.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/4445.png",
                },
                {
                  label: "Ben Stokes",
                  data: {
                    name: "Ben Stokes",
                    avatar: "ben_stokes.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1154.png",
                },
                {
                  label: "Rahul Tewatia",
                  data: {
                    name: "Rahul Tewatia",
                    avatar: "rahul_tewatia.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1749.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Wicket-keeper",
              image:
                "https://www.iplt20.com/assets/images/teams-wicket-keeper-icon.svg",
              data: {
                name: "Sanju Samson",
              },
              children: [
                {
                  label: "Sanju Samson",
                  data: {
                    name: "Sanju Samson",
                    avatar: "sanju_samson.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/258.png",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};

export const dc = {
  crew: [
    {
      expanded: true,
      label: "Franchise",
      data: {
        name: "Delhi Capitals",
        avatar: "dc.jpg",
      },
      image:
        "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/ipl/DC/Logos/LogoOutline/DCoutline.png",
      children: [
        {
          expanded: true,
          label: "Captain",
          data: {
            name: "Rishabh Pant",
            avatar: "rishabh_pant.jpg",
          },
          image:
            "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/2972.png",
          children: [
            {
              expanded: true,
              label: "Batsmen",
              image:
                "https://www.iplt20.com/assets/images/teams-batsman-icon.svg",
              data: {
                name: "Prithvi Shaw, Shikhar Dhawan, Steve Smith, Ajinkya Rahane",
              },
              children: [
                {
                  label: "Prithvi Shaw",
                  data: {
                    name: "Prithvi Shaw",
                    avatar: "prithvi_shaw.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/3764.png",
                },
                {
                  label: "Shikhar Dhawan",
                  data: {
                    name: "Shikhar Dhawan",
                    avatar: "shikhar_dhawan.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/41.png",
                },
                {
                  label: "Steve Smith",
                  data: {
                    name: "Steve Smith",
                    avatar: "steve_smith.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/271.png",
                },
                {
                  label: "Ajinkya Rahane",
                  data: {
                    name: "Ajinkya Rahane",
                    avatar: "ajinkya_rahane.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/135.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Bowlers",
              image:
                "https://www.iplt20.com/assets/images/teams-bowler-icon.svg",
              data: {
                name: "Kagiso Rabada, Anrich Nortje, Ravichandran Ashwin, Amit Mishra",
              },
              children: [
                {
                  label: "Kagiso Rabada",
                  data: {
                    name: "Kagiso Rabada",
                    avatar: "kagiso_rabada.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/1664.png",
                },
                {
                  label: "Anrich Nortje",
                  data: {
                    name: "Anrich Nortje",
                    avatar: "anrich_nortje.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/5433.png",
                },
                {
                  label: "Ravichandran Ashwin",
                  data: {
                    name: "Ravichandran Ashwin",
                    avatar: "ravichandran_ashwin.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/8.png",
                },
                {
                  label: "Amit Mishra",
                  data: {
                    name: "Amit Mishra",
                    avatar: "amit_mishra.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/30.png",
                },
              ],
            },
            {
              expanded: true,
              label: "All-rounders",
              image:
                "https://www.iplt20.com/assets/images/teams-all-rounder-icon.svg",
              data: {
                name: "Marcus Stoinis, Chris Woakes, Lalit Yadav",
              },
              children: [
                {
                  label: "Marcus Stoinis",
                  data: {
                    name: "Marcus Stoinis",
                    avatar: "marcus_stoinis.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/964.png",
                },
                {
                  label: "Chris Woakes",
                  data: {
                    name: "Chris Woakes",
                    avatar: "chris_woakes.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/967.png",
                },
                {
                  label: "Lalit Yadav",
                  data: {
                    name: "Lalit Yadav",
                    avatar: "lalit_yadav.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/6870.png",
                },
              ],
            },
            {
              expanded: true,
              label: "Wicket-keeper",
              image:
                "https://www.iplt20.com/assets/images/teams-wicket-keeper-icon.svg",
              data: {
                name: "Rishabh Pant",
              },
              children: [
                {
                  label: "Rishabh Pant",
                  data: {
                    name: "Rishabh Pant",
                    avatar: "rishabh_pant.jpg",
                  },
                  image:
                    "https://bcciplayerimages.s3.ap-south-1.amazonaws.com/playerheadshot/ipl/210/2972.png",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
export const tbl = {
  crew: [
    {
      expanded: true,
      label: "Franchise",
      data: {
        name: "Trailblazers",
        avatar: "vel.jpg",
      },
      image: "https://scores.iplt20.com/ipl/teamlogos/TBRoundbig.png",
      children: [
        {
          expanded: true,
          label: "Captain",
          data: {
            name: "Smriti Mandhana",
            avatar: "deepti_sharma.jpg",
          },
          image: "https://scores.iplt20.com/ipl/playerimages/401-small.png?v=2",
          children: [
            {
              expanded: true,
              label: "Batsmen",
              image:
                "https://www.iplt20.com/assets/images/teams-batsman-icon.svg",
              data: {
                name: "Smriti Mandhana, Hayley Matthews, Jemimah Rodrigues, Sharmin Akhter",
              },
              children: [
                {
                  label: "Smriti Mandhana",
                  data: {
                    name: "Smriti Mandhana",
                    avatar: "shafali_verma.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/401-small.png?v=2",
                },
                {
                  label: " Hayley Matthews",
                  data: {
                    name: " Hayley Matthews",
                    avatar: "k_p_navgire.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/918-small.png?v=2",
                },
                {
                  label: " Jemimah Rodrigues",
                  data: {
                    name: " Jemimah Rodrigues",
                    avatar: "deepti_sharma.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/388-small.png?v=2",
                },
                {
                  label: "Sharmin Akhter",
                  data: {
                    name: "Sharmin Akhter",
                    avatar: "natthakan_chantham.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/963-small.png?v=2",
                },
              ],
            },
            {
              expanded: true,
              label: "Bowlers",
              image:
                "https://www.iplt20.com/assets/images/teams-bowler-icon.svg",
              data: {
                name: "Arundhati Reddy, Poonam Yadav, Renuka Singh, Rajeshwari Gayakwad",
              },
              children: [
                {
                  label: "Arundhati Reddy",
                  data: {
                    name: "Arundhati Reddy",
                    avatar: "laura_wolvaardt.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/391-small.png?v=2",
                },
                {
                  label: "Poonam Yadav",
                  data: {
                    name: "Poonam Yadav",
                    avatar: "sneh_rana.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/394-small.png?v=2",
                },
                {
                  label: "Renuka Singh",
                  data: {
                    name: "Renuka Singh",
                    avatar: "radha_yadav.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/888-small.png?v=2",
                },
                {
                  label: "Rajeshwari Gayakwad",
                  data: {
                    name: "Rajeshwari Gayakwad",
                    avatar: "kathryn_laura_cross.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/393-small.png?v=2",
                },
              ],
            },
            {
              expanded: true,
              label: "All-rounders",
              image:
                "https://www.iplt20.com/assets/images/teams-all-rounder-icon.svg",
              data: {
                name: "Sophia Dunkley, Salma Khatun",
              },
              children: [
                {
                  label: "Sophia Dunkley",
                  data: {
                    name: "Sophia Dunkley",
                    avatar: "simran_bahadur.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/944-small.png?v=2",
                },
                {
                  label: "Salma Khatun",
                  data: {
                    name: "Salma Khatun",
                    avatar: "ayabonga_khaka.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/961-small.png?v=2",
                },
              ],
            },
            {
              expanded: true,
              label: "Wicket-keeper",
              image:
                "https://www.iplt20.com/assets/images/teams-wicket-keeper-icon.svg",
              data: {
                name: "Richa Ghosh",
              },
              children: [
                {
                  label: "Richa Ghosh",
                  data: {
                    name: "Richa Ghosh",
                    avatar: "yastika_bhatia.jpg",
                  },
                  image:
                    "https://scores.iplt20.com/ipl/playerimages/399-small.png?v=2",
                },
              ],
            },
          ],
        },
      ],
    },
  ],
};
export const sno = {
  "crew": [
    {
      "expanded": true,
      "label": "Franchise",
      "data": {
        "name": "Supernovas",
        "avatar": "sno.jpg"
      },
      "image": "https://scores.iplt20.com/ipl/teamlogos/SNRoundbig.png",
      "children": [
        {
          "expanded": true,
          "label": "Captain",
          "data": {
            "name": "Harmanpreet Kaur",
            "avatar": "deepti_sharma.jpg"
          },
          "image": "https://scores.iplt20.com/ipl/playerimages/387-small.png?v=2",
          "children": [
            {
              "expanded": true,
              "label": "Batsmen",
              "image": "https://www.iplt20.com/assets/images/teams-batsman-icon.svg",
              "data": {
                "name": "Priya Punia, Chandu V"
              },
              "children": [
                {
                  "label": "Priya Punia",
                  "data": {
                    "name": "Priya Punia",
                    "avatar": "shafali_verma.jpg"
                  },
                  "image": "https://scores.iplt20.com/ipl/playerimages/1032-small.png?v=2"
                },
                {
                  "label": "Chandu V",
                  "data": {
                    "name": "Chandu V",
                    "avatar": "k_p_navgire.jpg"
                  },
                  "image": "https://scores.iplt20.com/ipl/playerimages/1026-small.png?v=2"
                }
              ]
            },
            {
              "expanded": true,
              "label": "Bowlers",
              "image": "https://www.iplt20.com/assets/images/teams-bowler-icon.svg",
              "data": {
                "name": "Meghna Singh"
              },
              "children": [
                {
                  "label": "Meghna Singh",
                  "data": {
                    "name": "Meghna Singh",
                    "avatar": "laura_wolvaardt.jpg"
                  },
                  "image": "https://scores.iplt20.com/ipl/playerimages/886-small.png?v=2"
                }
              ]
            },
            {
              "expanded": true,
              "label": "All-rounders",
              "image": "https://www.iplt20.com/assets/images/teams-all-rounder-icon.svg",
              "data": {
                "name": "Deandra Dottin,Harleen Deol,Sune Luus ,Alana King ,Pooja Vastrakar ,Sophie Ecclestone "
              },
              "children": [
                {
                  "label": "Deandra Dottin",
                  "data": {
                    "name": "Deandra Dottin",
                    "avatar": "simran_bahadur.jpg"
                  },
                  "image": "https://scores.iplt20.com/ipl/playerimages/913-small.png?v=2"
                },
                {
                  "label": "Harleen Deol",
                  "data": {
                    "name": "Harleen Deol",
                    "avatar": "ayabonga_khaka.jpg"
                  },
                  "image": "https://scores.iplt20.com/ipl/playerimages/389-small.png?v=2"
                },
                {
                  "label": "Sune Luus",
                  "data": {
                    "name": "Sune Luus",
                    "avatar": "simran_bahadur.jpg"
                  },
                  "image": "https://scores.iplt20.com/ipl/playerimages/434-small.png?v=2"
                },
                {
                  "label": "Alana King",
                  "data": {
                    "name": "Alana King",
                    "avatar": "simran_bahadur.jpg"
                  },
                  "image": "https://scores.iplt20.com/ipl/playerimages/967-small.png?v=2"
                },
                {
                  "label": "Pooja Vastrakar",
                  "data": {
                    "name": "Pooja Vastrakar",
                    "avatar": "simran_bahadur.jpg"
                  },
                  "image": "https://scores.iplt20.com/ipl/playerimages/397-small.png?v=2"
                },
                {
                  "label": "Sophie Ecclestone",
                  "data": {
                    "name": "Sophie Ecclestone",
                    "avatar": "simran_bahadur.jpg"
                  },
                  "image": "https://scores.iplt20.com/ipl/playerimages/406-small.png?v=2"
                }
              ]
            },
            {
              "expanded": true,
              "label": "Wicket-keeper",
              "image": "https://www.iplt20.com/assets/images/teams-wicket-keeper-icon.svg",
              "data": {
                "name": "Taniya Bhatia"
              },
              "children": [
                {
                  "label": "Taniya Bhatia",
                  "data": {
                    "name": "Taniya Bhatia",
                    "avatar": "yastika_bhatia.jpg"
                  },
                  "image": "https://scores.iplt20.com/ipl/playerimages/396-small.png?v=2"
                }
              ]
            }
          ]
        }
      ]
    }
  ]
}
